"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goalConfigDefaultValue = exports.goalConfigSchema = void 0;
const zod_1 = require("zod");
const RoundModeValues = ['truncate', 'roundUp', 'roundDown'];
const separators = ['.', ','];
exports.goalConfigSchema = zod_1.z.object({
    percentageOpts: zod_1.z.object({
        roundMode: zod_1.z.enum(RoundModeValues),
        decimals: zod_1.z.number(),
    }),
    labelOpts: zod_1.z
        .object({
        prefix: zod_1.z.string().optional(),
        decimals: zod_1.z.number().optional().default(2),
        decimalSeparator: zod_1.z.enum(separators).optional().default(','),
        thousandSeparator: zod_1.z.enum(separators).optional().default('.'),
        roundMode: zod_1.z.enum(RoundModeValues).optional().default('truncate'),
    })
        .optional(),
    coloring: zod_1.z
        .array(zod_1.z.object({
        startPercentage: zod_1.z.number(),
        endPercentage: zod_1.z.number(),
        color: zod_1.z.string(),
        default: zod_1.z.boolean().optional(),
    }))
        .optional(),
});
const defaultValue = {
    coloring: [{ color: '#FFF', default: true, endPercentage: 100, startPercentage: 0 }],
    labelOpts: {
        decimals: 2,
        decimalSeparator: ',',
        thousandSeparator: '.',
        roundMode: 'truncate',
        prefix: '%',
    },
    percentageOpts: {
        decimals: 2,
        roundMode: 'truncate',
    },
};
exports.goalConfigDefaultValue = JSON.stringify(defaultValue, null, '\t');
